type JsonObject = Record<string, unknown>;

export function JsonLd({ data }: { data: JsonObject | JsonObject[] }) {
  // Stringify once, escape `</` so a stray closing tag inside JSON can't break the script element.
  const json = JSON.stringify(data).replace(/</g, "\\u003c");
  return (
    <script
      type="application/ld+json"
      // eslint-disable-next-line react/no-danger -- structured data injection
      dangerouslySetInnerHTML={{ __html: json }}
    />
  );
}
